<template>
    <figure class="guia" aria-label="Dónde aparece el número de registro en el certificado">
        <svg viewBox="0 0 150 194" role="img" class="guia__svg">
            <title>Certificado con el número de registro resaltado</title>
            <rect x="1" y="1" width="148" height="192" rx="4" fill="#fff" stroke="#c9d0e3"/>
            <rect x="7" y="7" width="136" height="180" rx="2" fill="none" stroke="#e4b96f" stroke-width="1.2"/>

            <rect x="55" y="16" width="40" height="7" rx="1.5" fill="#203d89" opacity=".85"/>
            <rect x="40" y="29" width="70" height="3" rx="1.5" fill="#d4d9e8"/>

            <rect x="24" y="47" width="102" height="2.5" rx="1.2" fill="#dfe3ef"/>
            <rect x="18" y="58" width="114" height="6" rx="1.5" fill="#203d89" opacity=".75"/>
            <rect x="34" y="70" width="82" height="3" rx="1.5" fill="#d4d9e8"/>
            <rect x="40" y="78" width="70" height="3" rx="1.5" fill="#d4d9e8"/>
            <rect x="28" y="88" width="94" height="2.5" rx="1.2" fill="#dfe3ef"/>
            <rect x="30" y="98" width="90" height="2.5" rx="1.2" fill="#dfe3ef"/>

            <g class="guia__registro">
                <rect x="14" y="107" width="122" height="14" rx="3" fill="#fff4de" stroke="#d29e4a" stroke-width="1.5"/>
                <text x="21" y="117" font-size="6.2" font-weight="700" fill="#7a4f10" font-family="Roboto, Arial, sans-serif">Registro No.</text>
                <text x="63" y="117" font-size="6.6" font-weight="700" fill="#203d89" font-family="Roboto, Arial, sans-serif" letter-spacing=".3">2658171</text>
            </g>

            <rect x="20" y="138" width="40" height="14" rx="1" fill="none" stroke="#d4d9e8" stroke-dasharray="2 2"/>
            <rect x="90" y="138" width="40" height="14" rx="1" fill="none" stroke="#d4d9e8" stroke-dasharray="2 2"/>
            <rect x="22" y="154" width="36" height="2.5" rx="1.2" fill="#dfe3ef"/>
            <rect x="92" y="154" width="36" height="2.5" rx="1.2" fill="#dfe3ef"/>

            <rect x="112" y="162" width="20" height="20" rx="1.5" fill="#1b2340"/>
            <rect x="115" y="165" width="5" height="5" fill="#fff"/>
            <rect x="124" y="165" width="5" height="5" fill="#fff"/>
            <rect x="115" y="174" width="5" height="5" fill="#fff"/>
            <rect x="123" y="173" width="2" height="2" fill="#fff"/>
            <rect x="127" y="176" width="2" height="2" fill="#fff"/>
        </svg>
        <figcaption class="guia__texto">
            <strong>¿Dónde está el número de registro?</strong>
            En el certificado, debajo de la fecha, junto al texto <em>"Registro No."</em>.
            Son solo dígitos; escríbelo sin letras ni espacios.
        </figcaption>
    </figure>
</template>

<script>
/** Ilustración del certificado con el número de registro resaltado (pantalla de ingreso). */
export default {
    name: "CertificadoGuia",
}
</script>

<style lang="scss" scoped>
.guia {
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 0 0 18px;
    padding: 12px 14px;
    border-radius: 12px;
    background: #f3f5fa;
    border: 1px solid #dce1ec;
}

.guia__svg {
    width: 84px;
    flex: none;
    filter: drop-shadow(0 2px 4px rgba(27, 35, 64, .12));
}

.guia__registro {
    animation: pulso 2.2s ease-in-out infinite;
    transform-origin: 75px 114px;
}

.guia__texto {
    font-size: 12.5px;
    line-height: 1.5;
    color: #5b6480;

    strong {
        display: block;
        color: #1b2340;
        margin-bottom: 2px;
    }

    em {
        font-style: normal;
        font-weight: 600;
        color: #7a4f10;
    }
}

@keyframes pulso {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.04); }
}

@media (prefers-reduced-motion: reduce) {
    .guia__registro { animation: none; }
}
</style>
